module.exports = __webpack_public_path__ + "static/img/consumer touch point.e1b2db6f.png";